import ModuleAccessOverlay from '../components/ModuleAccessOverlay.vue';

const ModuleAccessOverlayPlugin = {
  install(Vue) {
    // Register the component globally
    Vue.component('ModuleAccessOverlay', ModuleAccessOverlay);
    
    // Create a global event bus
    const eventBus = new Vue();

    // Add instance method
    Vue.prototype.$moduleAccessOverlay = {
      show(moduleSlug, options = {}) {
        eventBus.$emit('show-module-access-overlay', { moduleSlug, ...options });
      },
      hide() {
        eventBus.$emit('hide-module-access-overlay');
      },
      // Listen for events from the component
      $on(event, callback) {
        eventBus.$on(event, callback);
      },
      $off(event, callback) {
        eventBus.$off(event, callback);
      }
    };
  }
};

export default ModuleAccessOverlayPlugin;
